// WebSocketContext.js
import React, { createContext, useContext, useEffect, useRef } from 'react';

const WebSocketContext = createContext(null);

export function WebSocketProvider({ children }) {
  const ws = useRef(null);
  const subscriptions = useRef(new Map());
  const reconnectTimeout = useRef(null);

  useEffect(() => {
    // Initialize WebSocket connection
    const connect = () => {
      const token = 'test_token';
      
      ws.current = new WebSocket(`wss://rtbuffer.tint.tetraagroup.com/ws/subscribe?token=${token}`);
      ws.current.headers = new Headers({
        'token': token
      });

      ws.current.onopen = () => {
        console.log('Connected to WebSocket');
        // Resubscribe to all active subscriptions after reconnect
        subscriptions.current.forEach((subscription, tag) => {
          console.log(tag, Array.from(subscription.types));
          sendSubscription(tag, Array.from(subscription.types));
        });
      };

      ws.current.onmessage = (event) => {
        const data = JSON.parse(event.data);
        console.log('Received update:', data);
        // Notify all subscribers
        const subscribers = subscriptions.current.get(data.tag);
        if (subscribers) {
          subscribers.callbacks.forEach(callback => callback(data));
        }
      };

      ws.current.onclose = () => {
        console.log('WebSocket disconnected. Attempting to reconnect...');
        reconnectTimeout.current = setTimeout(connect, 3000);
      };

      ws.current.onerror = (error) => {
        console.error('WebSocket error:', error);
      };
    };

    connect();
    return () => {
      if (ws.current) {
        ws.current.close();
      }
      if (reconnectTimeout.current) {
        clearTimeout(reconnectTimeout.current);
      }
    };
  }, []);

  const sendSubscription = (tag, types) => {
    console.log('Sending subscription:', tag, types);
    if (ws.current?.readyState === WebSocket.OPEN) {
      const subscription = {
        site_id: 1,
        action: 'subscribe',
        tag: tag,
        types: types
      };
      ws.current.send(JSON.stringify(subscription));
    }
  };

  const subscribe = (tag, types, callback) => {
    const existing = subscriptions.current.get(tag);
    if (existing) {
      existing.callbacks.add(callback);
      existing.types = new Set([...existing.types, ...types]);
    } else {
        subscriptions.current.set(tag, {
        callbacks: new Set([callback]),
        types: new Set(types)
      });
      sendSubscription(tag, Array.from(types));
    }
  };

  const unsubscribe = (tag, callback) => {
    const existing = subscriptions.current.get(tag);
    if (existing) {
      existing.callbacks.delete(callback);
      if (existing.callbacks.size === 0) {
        subscriptions.current.delete(tag);
        if (ws.current?.readyState === WebSocket.OPEN) {
          ws.current.send(JSON.stringify({
            site_id: 1,
            action: 'unsubscribe',
            tag: tag
          }));
        }
      }
    }
  };

  return (
    <WebSocketContext.Provider value={{ subscribe, unsubscribe }}>
      {children}
    </WebSocketContext.Provider>
  );
}

export const useWebSocket = () => useContext(WebSocketContext);